import {Component, NgZone, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {User} from 'projects/core/src/lib/login/data/user';
import {MatDialog} from '@angular/material/dialog';
import {OverlayPanel} from 'primeng/overlaypanel';
import {NotificationService} from 'projects/app-misc/src/app/modules/notification/data/notification.service';
import {SearchService} from 'projects/app-misc/src/app/modules/search/data/search.service';
import {NotificationsQuery} from 'projects/app-misc/src/app/modules/notification/data/notifications.query';
import {AppStateQuery} from '../../data/app-state.query';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {ProjectWindowComponent} from '../../modules/project/view/project-window/project-window.component';
import {UserProfile} from 'projects/app-misc/src/app/modules/profile/utils/profile.utils';
import {WsUpdateResponce} from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import {Notification} from 'projects/app-misc/src/app/modules/notification/data/notification';
import {WsService} from 'projects/app-misc/src/app/modules/data/ws.service';
import {UserNotification} from 'projects/app-misc/src/app/modules/notification/data/user-notification';
import {debounceTime, filter, skip, takeUntil} from 'rxjs/operators';
import {environment} from 'projects/desktop/src/environments/environment';
import {ProjectAlert} from 'projects/app-misc/src/app/modules/alert/data/alert';
import {Task} from '../../modules/home-page/data/tasks/task';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {AllHeaderButtons, MenuButton} from './navigation/nav-data';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {Subject, Subscription, timer} from 'rxjs';
import {LoginService} from '../../../../../core/src/lib/login/data/login.service';
import {Router} from '@angular/router';
import {LocalStorage} from 'ngx-webstorage';
import {ShortObject} from '../../../../../app-misc/src/app/modules/project-misc/data/project/short-json-object';
import {AutoComplete} from 'primeng/autocomplete';

@Component({
    selector: 'app-ac-system-header',
    templateUrl: './ac-system-header.component.html',
    styleUrls: ['./ac-system-header.component.scss'],
    providers: [SearchService]
})
@RxJSUnsubscribe
export class AcSystemHeaderComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
    currentUser: User

    @ViewChild('searchOP', {static: true})
    searchOP: OverlayPanel

    @ViewChild('pbOP', {static: true})
    profileOP: OverlayPanel

    @ViewChild('autoComplete')
    autoComplete: AutoComplete

    searchValue: string;

    unreadNotificationsCount = this.notificationQuery.totalUnread

    projects: ShortObject[];

    userProfile: UserProfile;

    linkStatus = this.appStateQuery.wsSocketReady$.pipe(skip(1));

    testProd = environment.dev;

    projectAlertsCount: number;

    taskSocketEmit = false;

    mentionsCounter: number;

    menuButtons: MenuButton[];

    systemState = environment.systemState

    systemStates = [{
        title: 'Seattle'
    }, {
        title: 'California'
    }]

    nfsWsSub: Subscription;
    mntsWsSub: Subscription;
    alrtsWsSub: Subscription;
    tasksWsSub: Subscription;

    headerScroll = false;

    @LocalStorage()
    projectHistorySearch: ShortObject[];

    showTimeClock = false;

    currentUrl: string;

    constructor(
        protected ngZone: NgZone,
        protected renderer: Renderer2,
        private router: Router,
        private loginService: LoginService,
        protected dialog: MatDialog,
        protected notificationService: NotificationService,
        protected notificationQuery: NotificationsQuery,
        protected appStateQuery: AppStateQuery,
        private searchService: SearchService,
        private userService: UserService,
        private projectService: ProjectService,
        protected wsService: WsService
    ) {
    }

    ngOnInit() {
        if (!this.projectHistorySearch) {
            this.projectHistorySearch = []
        }

        this.currentUrl = this.router.url;

        this.appStateQuery.currentUser$.subscribe(currentUser => {
            this.currentUser = currentUser;

            this.appStateQuery.rolesAccessMap$.subscribe(accessMap => {

                this.menuButtons = AllHeaderButtons
                    .filter(button => {
                        if (button.ignoreRestrictions) return true
                        if (!accessMap.has(button.url)) return false
                        const requiredRoles = accessMap.get(button.url)
                        return requiredRoles.includes('*') || currentUser.roles.map(role => role.name).find(value => requiredRoles.includes(value))
                    })
            })


            this.appStateQuery.userProfile$.subscribe(userProfile => this.userProfile = userProfile)
        });

        this.updateNfs();

        this.getMentions();

        this.getAlertsCount();

        this.wsSubToNfs();

        this.wsSubToAlerts();

        this.wsSubToTasks();

    }

    wsSubToNfs() {
        this.nfsWsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<Notification>>('/topic/update/model.notification.Notification', this)
            .pipe(
                debounceTime(2000),
                takeUntil(this.getUnsubFromAllSubs())
            )
            .subscribe(() => {
                this.updateNfs();
            })

        this.mntsWsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<UserNotification>>('/topic/update/model.notification.MentionNotification', this)
            .pipe(
                debounceTime(2000),
                takeUntil(this.getUnsubFromAllSubs())
            )
            .subscribe(() => {
                this.getCounter();
            })
    }

    wsSubToAlerts() {
        this.alrtsWsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<ProjectAlert>>('/topic/update/model.notification.alert.ProjectAlert', this)
            .pipe(
                debounceTime(2000),
                takeUntil(this.getUnsubFromAllSubs())
            )
            .subscribe(() => {
                this.getAlertsCount();
            })
    }


    wsSubToTasks() {
        this.tasksWsSub = this.wsService.listenUntilDestroyed<WsUpdateResponce<Task>>('/topic/update/model.task.task', this)
            .pipe(
                filter(updateInfo => updateInfo.entity.assignedUser.id === this.currentUser.id),
                debounceTime(2000)
            )
            .subscribe(updateInfo => {
                if (updateInfo.action === 'CREATE' || updateInfo.action === 'UPDATE') this.taskSocketEmit = true;
            })
    }

    getMentions() {
        this.notificationService.unreadMentions.subscribe(() => {
            this.getCounter();
        })
    }

    getCounter() {
        this.notificationService.getMentionsCounter().subscribe(counter => {
            this.mentionsCounter = counter.mentionsUnread;
        })
    }

    updateNfs() {
        this.notificationService.loadUnreadedNotificationsCount()
    }

    getAlertsCount() {
        this.notificationService.getCountOfAlerts().subscribe(alerts => this.projectAlertsCount = alerts);
    }

    filterProjects(event) {
        const query = event.query;

        this.projectService
            .searchProjects(query)
            .subscribe(projs => {
                this.projects = projs
                this.showTimeClock = false;
            })
    }

    openProject(project: ShortObject) {
        this.searchValue = '';
        this.showTimeClock = false;

        this.dialog.open(ProjectWindowComponent, {
            data: {
                projectNumber: project.id,
            },
            panelClass: 'project-window-dialog'
        });

        this.updateHistory(project)
        this.autoComplete.hide()
        setTimeout(() => {
            this.autoComplete.inputEL.nativeElement.blur();
        }, 50);
    }

    updateHistory(project) {
        const tempArr = [...this.projectHistorySearch];

        const fIndex = tempArr.findIndex(proj => proj.id === project.id);

        if (fIndex >= 0) {
            tempArr.splice(fIndex, 1)
        }

        tempArr.unshift({
            id: project.id,
            name: project.name
        })

        if (tempArr.length > 4) {
            tempArr.pop()
        }

        this.projectHistorySearch = [...tempArr]
    }

    switchSystem(clickedSys: string) {
        this.loginService.switchSystem(clickedSys)
    }

    startScrollOnDrag(boardWrapper: HTMLElement, event: MouseEvent) {

        this.ngZone.runOutsideAngular(() => {
            const startX = event.pageX - 7;
            const scrollLeft = boardWrapper.scrollLeft;

            let stopListenMouseMove: () => void;
            let stopListenMouseUp: () => void;
            let stopListenMouseLeave: () => void;

            const stopListenAll = () => {
                stopListenMouseMove();
                stopListenMouseUp();
                stopListenMouseLeave();
            }

            stopListenMouseMove = this.renderer.listen(boardWrapper, 'mousemove', (mouseMoveEvt: MouseEvent) => {
                mouseMoveEvt.preventDefault();

                const x = mouseMoveEvt.pageX - 7;
                const walk = (x - startX);
                boardWrapper.scrollLeft = scrollLeft - walk;

                if (walk < -50 || walk > 50) {
                    this.headerScroll = true;
                }
            });

            stopListenMouseUp = this.renderer.listen(boardWrapper, 'mouseup', (mouseUpEvt: MouseEvent) => {
                timer(1).subscribe(() => {
                    this.headerScroll = false;
                })
                stopListenAll();
            });


            stopListenMouseLeave = this.renderer.listen(boardWrapper, 'mouseleave', (mouseLeaveEvt: MouseEvent) => {
                timer(1).subscribe(() => {
                    this.headerScroll = false;
                })
                stopListenAll();
            });

        });
    }

    ngOnDestroy() {
        this.nfsWsSub.unsubscribe()
        this.nfsWsSub = null;
        this.mntsWsSub.unsubscribe()
        this.mntsWsSub = null;
        this.alrtsWsSub.unsubscribe()
        this.alrtsWsSub = null;
        this.tasksWsSub.unsubscribe()
        this.tasksWsSub = null;

        this.dialog.closeAll();
    }

    routerButton(url: string) {
        if (!this.headerScroll) {
            this.router.navigate([url])

            this.currentUrl = url;

        }
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

    projectsFromHistory() {
        if (!this.searchValue) {
            this.projects = this.projectHistorySearch;
            this.autoComplete.writeValue('')
            this.showTimeClock = true;
        }

        if (this.projects && this.projects.length > 0) {
            this.autoComplete.show()
        }
    }
}
